import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header/header";
import { useSelector, useDispatch } from "react-redux";
import { toggleTheme } from "../redux/slices/toggleSlice";
// import HeaderLineLoader from "../components/loader";

const Layout = () => {
  const { email, name, role, currency } = useSelector((state) => state.user);
  const theme = useSelector((state) => state.theme.mode);
  const loadingCount = useSelector((state) => state.loader.loadingCount);
  const globalLoading = loadingCount > 0;

  const dispatch = useDispatch();

  useEffect(() => {
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
  }, [theme]);

  return (
    <div className="">
      <div className="flex-1 flex flex-col bg-white dark:bg-custom-radial min-h-screen">
        <Header
          email={email}
          name={name}
          role={role}
          theme={theme}
          toggleTheme={() => dispatch(toggleTheme())}
        />
        {/* <HeaderLineLoader loading={globalLoading} /> */}
        <main className="flex-grow p-4  pt-20 text-white bg-[#F6F6F6] dark:bg-custom-radial">
          <Outlet context={{ email, name, role, currency }} />
        </main>
      </div>
    </div>
  );
};

export default Layout;
